import axiosInstance from "./axiosInstance";

const roleService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/roles/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllRoles: async () => {
        try {
            const response = await axiosInstance.get('/roles/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/roles/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchRoleById: async (id) => {
        try {
            const response = await axiosInstance.get('/roles/id/' + id);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/roles/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default roleService;
